module.exports = __webpack_public_path__ + "static/img/shuzi2.76736434.png";